<template>
  <el-tooltip :disabled='disabled' :content="title" placement="top" effect="light">
    <span ref="span" class="textOverflow">{{title}}</span>
  </el-tooltip>
</template>

<script>
export default {
  name: 'overflowTooltip',
  components: {
  },
  props: {
    title: {
    }
  },
  watch: {
    title: {
      deep: true,
      immediate: true,
      handler(val) {
        this.changeTitle()
      }
    },
  },
  data() {
    return {
      disabled: false
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    changeTitle() {
      this.$nextTick(() => {
        const { scrollWidth, offsetWidth } = this.$refs.span || { scrollWidth: 0, offsetWidth: 0 }
        this.disabled = scrollWidth <= offsetWidth
      }, 0)
    }
  }
}
</script>

<style scoped lang="scss">
</style>